/*
  CFBL source tracking. Records, in the visitor's own browser only, where they first came
  from and which page they landed on, then prints that into the contact form email.
  Nothing is sent to any outside service. Nothing about the reason for contact is recorded.
*/
(function () {
  var FIRST = 'cfbl_src_first', LATEST = 'cfbl_src_latest', DAYS = 180;
  var NAMES = [
    [/(^|\.)google\./, 'Google search'], [/(^|\.)bing\.com$/, 'Bing search'], [/(^|\.)duckduckgo\.com$/, 'DuckDuckGo search'],
    [/(^|\.)yahoo\./, 'Yahoo search'], [/instagram\.com$/, 'Instagram'], [/(^|\.)(facebook\.com|fb\.com|fb\.me)$/, 'Facebook'],
    [/(^|\.)(linkedin\.com|lnkd\.in)$/, 'LinkedIn'], [/(^|\.)tiktok\.com$/, 'TikTok'], [/(^|\.)(youtube\.com|youtu\.be)$/, 'YouTube'],
    [/psychologytoday\.com$/, 'Psychology Today'], [/(^|\.)(chatgpt\.com|openai\.com)$/, 'ChatGPT'], [/perplexity\.ai$/, 'Perplexity'],
    [/(^|\.)claude\.ai$/, 'Claude'], [/maps\.apple\.com$/, 'Apple Maps'], [/(^|\.)yelp\.com$/, 'Yelp'], [/mail\.|outlook\./, 'An email']
  ];
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function name(host) { for (var i = 0; i < NAMES.length; i++) if (NAMES[i][0].test(host)) return NAMES[i][1]; return host.replace(/^www\./, ''); }
  function today() { var d = new Date(); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }

  var here = location.hostname.replace(/^www\./, ''), q = new URLSearchParams(location.search), ref = '';
  try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
  var external = ref && ref.replace(/^www\./, '') !== here && !/(^|\.)myshopify\.com$|shopify\.com$/.test(ref);
  var campaign = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].map(function (k) { return q.get(k) ? k.replace('utm_', '') + ': ' + q.get(k) : ''; }).filter(Boolean).join(', ');
  var path = location.pathname || '/';

  var first = store(FIRST);
  if (first && first.t && (Date.now() - first.t) > DAYS * 864e5) first = null;
  var touch = null;
  if (external || campaign) touch = { source: external ? name(ref) : (q.get('utm_source') || 'Campaign link'), landing: path, campaign: campaign, date: today(), t: Date.now() };
  if (!first) { first = touch || { source: 'Direct (typed the address, a bookmark, or an app that hides its source)', landing: path, campaign: '', date: today(), t: Date.now() }; store(FIRST, first); }
  if (touch) store(LATEST, touch);
  var latest = store(LATEST) || first;

  function fill(form) {
    var map = {
      source: first.source, landing: first.landing, firstdate: first.date, campaign: first.campaign || latest.campaign || 'None',
      latest: latest.source + (latest.landing ? ' (landed on ' + latest.landing + ')' : '') + (latest.date ? ', ' + latest.date : ''),
      formpage: path
    };
    [].forEach.call(form.querySelectorAll('[data-cfbl-src]'), function (el) { var v = map[el.getAttribute('data-cfbl-src')]; if (v) el.value = v; });
  }
  function init() {
    [].forEach.call(document.querySelectorAll('form'), function (f) {
      if (!f.querySelector('[data-cfbl-src]')) return;
      fill(f); f.addEventListener('submit', function () { fill(f); });
    });
    // Tag email buttons with the page they were clicked on, so the email says which page sent it.
    var page = (document.title || '').split(/\s[|\u2013\u2014-]\s/)[0].trim();
    if (!page) return;
    [].forEach.call(document.querySelectorAll('a[href^="mailto:"]'), function (a) {
      var href = a.getAttribute('href');
      if (!/[?&]subject=/i.test(href) || a.dataset.cfblTagged) return;
      a.setAttribute('href', href.replace(/([?&]subject=)([^&]*)/i, function (m, k, v) { return k + v + encodeURIComponent(' (' + page + ' page)'); }));
      a.dataset.cfblTagged = '1';
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
